#### Partner token expiry time will be reduced

**What is the change?**

On the 2nd of June at 9am AEST, the lifetime of SEEK API [partner tokens](/auth/partner-tokens) will be reduced from 24 hours to 30 minutes.
Your hirers may be unable to post job ads and receive candidate applications if your SEEK integration does not comply with token expiry best practices after this date.

**Why is this happening?**

This change is a routine security upgrade to safeguard both SEEK and our partners in the event of a compromised API credential.

**Action required from partners**

No action is required if your software caches partner tokens based on the number of seconds specified in the `expires_in` of the partner token response.

If your software has hardcoded the token’s expiry or you are not currently caching partner tokens, you must update it to cache dynamically as described in our [partner token documentation](/auth/partner-tokens).

**When do partners need to make this change by?**

In line with the [SEEK API terms](https://au.employer.seek.com/partners/terms-of-use#api-versioning), this change needs to be completed within 30 days (before the 2nd of June) to avoid hirer impact.
It is estimated to take less than 1 day of effort.
Reach out if you have any concerns with the above change.
Subscribe to our [release notes](/introduction/release-notes) and [status page](https://status.seek.com) to be notified of future updates.
